import { driver_today_appointment_deliveries } from "../../../networking/urlEndPoints";
import Axios from "../../../networking/interceptor";

export const fetchTodayAppointmentDeliveries = async (pharmacyId, clinicName = "") => {
	if (!pharmacyId) {
		throw new Error("pharmacy_id is required");
	}

	const response = await Axios.get(driver_today_appointment_deliveries, {
		params: {
			pharmacy_id: pharmacyId,
			...(clinicName ? { clinic: clinicName } : {}),
		},
	});

	return response.data?.data ?? response.data;
};
